import { PageHeader, Stack, TabNav, type TabNavItem } from '@ui';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';
import { PageActionsProvider, PageActionsSlot } from '../../app/PageActions';
import { RouterLink } from '../../app/RouterLink';

/** Frame of the finance pages: title, the tab's actions and tabs. */
export function FinanceLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const tabs: TabNavItem[] = (
    [
      { key: 'overview', label: t('finance.tabs.overview'), href: '/finanzen' },
      { key: 'entries', label: t('finance.tabs.entries'), href: '/finanzen/buchungen' },
      { key: 'categories', label: t('finance.tabs.categories'), href: '/finanzen/kategorien' },
    ] satisfies TabNavItem[]
  ).map((tab) => ({
    ...tab,
    active: tab.href === '/finanzen' ? pathname === '/finanzen' : pathname.startsWith(tab.href),
  }));
  return (
    <PageActionsProvider>
      <Stack gap={4}>
        <PageHeader title={t('finance.title')} actions={<PageActionsSlot />} />
        <TabNav label={t('finance.tabs.label')} items={tabs} linkComponent={RouterLink} />
        <Outlet />
      </Stack>
    </PageActionsProvider>
  );
}
